import { ButtonGroup, IPageRange, PagingOptions, SearchBox, Select, ToolMenu, ToolMenuContent } from '@aon/aon-tws-common-ui';
import React from 'react';
import styled from 'styled-components';
import ContentConstants from '../../../contentConstants';
import { IColumn } from '../../../models';
import { ColumnHelper } from '../../../utilities';

export type AudienceTableUtilitiesProps = {
	surveyId: number;
	resultsCount: number;
	pageRange: IPageRange;
	columns: IColumn[];
	onSearch: (searchText: string) => void;
	onColumnChange: (searchText: string[]) => void;
	onPageChange: (pageRange: IPageRange) => void;
};

const TableUtilitiesContainer = styled.div.attrs<{}>({
	className: 'tws-table-utlities-container',
	'data-testid': 'tws-table-utlities-container',
})`
	display: flex;
`;
TableUtilitiesContainer.displayName = 'TableUtilitiesContainer';

export const AudienceTableUtilities = (props: AudienceTableUtilitiesProps) => {
	return (
		<>
			<PagingOptions pageRange={props.pageRange} updatePageRange={props.onPageChange} />
			<ToolMenu>
				<ToolMenuContent type={'right'}>
					<SearchBox resultsCount={props.resultsCount} callbackFunc={props.onSearch} inputSize='sm' />
				</ToolMenuContent>
				<ToolMenuContent type='left'>
					<ButtonGroup type='vertical'>
						<Select
							items={props.columns}
							multiple={true}
							selectedValues={ColumnHelper.GetSelectedColumnNames(props.columns)}
							onApply={(values?: string | string[] | undefined) => props.onColumnChange(values as string[])}
							showCount={true}
							displayText={ContentConstants.COLUMNPICKER_TITLE}
							selectWidth='180px'
							optionsContainerWidth='250px'
							size='sm'
						/>
					</ButtonGroup>
				</ToolMenuContent>
			</ToolMenu>
		</>
	);
};
